<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :stroke-width="stroke_width || '2'" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" fill="none" viewBox="0 0 26 26" style="enable-background:new 0 0 26 26;" xml:space="preserve" :class="class">
        <g>
            <path d="M21,16.9h3.8v-4.5"/>
            <path d="M24.5,16.9c-.7-2.7-3.2-4.6-5.9-4.5-2.8,0-5.2,2-5.7,4.7s.8,5.5,3.3,6.7c2.5,1.2,5.5.5,7.3-1.7"/>
            <path d="M5.2,7.9h10.5"/>
            <path d="M5.2,12.4h6"/>
            <path d="M5.2,16.9h3.8"/>
            <path d="M9,21.4H3.7c-.8,0-1.5-.7-1.5-1.5V3.4c0-.8.7-1.5,1.5-1.5h10.6c.4,0,.8.2,1.1.4l2.9,2.9c.3.3.4.7.4,1.1v2.4"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['class', 'stroke_width'],
}
</script>